import React from 'react'

import PropTypes from 'prop-types'

import Button from './button'
import './whatsapp.css'

const Whatsapp = (props) => {
  return (
    <div className="whatsapp-container">
      <Button vectorSrc={props.buttonVectorSrc}></Button>
    </div>
  )
}

Whatsapp.defaultProps = {
  buttonVectorSrc: '/external/vectori374-fc5.svg',
}

Whatsapp.propTypes = {
  buttonVectorSrc: PropTypes.string,
}

export default Whatsapp
